<template>
  <NuxtLayout>
    <NuxtLoadingIndicator color="text-theme-secondary"
                          :height="10" />
    <div>
    <ErrorView :error="error" />
      <h2>{{error?.statusCode}}</h2>
      <p>{{error?.message}}</p>
      <p>{{ error?.stack}}</p>
    </div>
  </NuxtLayout>
</template>
<script setup lang="ts">
import type { NuxtError } from '#app'

const props = defineProps({
  error: Object as () => NuxtError
})

const error = useError();
const handleError = () => clearError({ redirect: '/' })

</script>

